import React from "react";

const BrandingContext = React.createContext();

export const BrandingProvider = BrandingContext.Provider;
export const BrandingConsumer = BrandingContext.Consumer;

export default BrandingContext;
